// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

  .form-footer {
    display: flex;
    justify-content: center;
    padding: 10px 0 0 0;
  }
  .login-field-label {
    font-weight: bold;
    font-size: 14px;
    padding: 10px 2px;
  }
  .login-form-header {
    font-size: 20px;
    font-weight: bold;
    padding: 20px 15px;
  }
.activate-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.activate-message {
  display: flex;
  font-size: 20px;
  font-weight: bold;
}
  `, "",{"version":3,"sources":["webpack://./src/app/components/login-page/activate-user.ts"],"names":[],"mappings":";;EAEE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;AACF;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB","sourcesContent":["\n\n  .form-footer {\n    display: flex;\n    justify-content: center;\n    padding: 10px 0 0 0;\n  }\n  .login-field-label {\n    font-weight: bold;\n    font-size: 14px;\n    padding: 10px 2px;\n  }\n  .login-form-header {\n    font-size: 20px;\n    font-weight: bold;\n    padding: 20px 15px;\n  }\n.activate-content {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n.activate-message {\n  display: flex;\n  font-size: 20px;\n  font-weight: bold;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
